import Quill, { Parchment } from "quill";

////////////////////////////////////////////////////////////////////////////////

const BlockEmbed = Quill.import("blots/block/embed") as typeof Parchment.EmbedBlot;

export default class VideoUrlBlot extends BlockEmbed {

    static blotName = 'videoUrl';
    static tagName = 'video';

    static create(value: any) {
        const node = (super.create(null) as any);

        if (typeof value == "string") {
            value = { src: value };
        }

        // Ajusta proporção do vídeo.
        var h = value.height || 240;
        var w = value.width || 320;
        var p = 1.0;

        if (w > h && w > 640) p = 640 / value.width;
        else if (h > 480) p = 480 / value.height;

        w = w * p;
        h = h * p;

        // Aplica valores
        node.setAttribute('controls', 'controls');
        node.setAttribute('width', w + 'px');
        node.setAttribute('height', h + 'px');

        var source = document.createElement("source");
        source.setAttribute('src', value.src);
        node.setAttribute('title', value.title);
        source.setAttribute('type', "video/mp4");

        node.appendChild(source);

        return node;
    }

    static formats(node: any) {
        const format: any = {};
        if (node.hasAttribute('height')) {
            format.height = node.getAttribute('height');
        }
        if (node.hasAttribute('width')) {
            format.width = node.getAttribute('width');
        }
        if (node.hasAttribute('title')) {
            format.title = node.getAttribute('title');
        }
        return format;
    }

    static value(node: any) {
        // Na criação, 'node' será preenchido com os dados do vídeo em formato json.
        // Na edição, 'node' será uma tag '<video />'.
        return {
            title: node.getAttribute('title'),
            src: node.tagName == "VIDEO" ? node.firstChild.src : node.getAttribute('src'),
            width: node.getAttribute('width'),
            height: node.getAttribute('height'),
        };
    }

    format(name: any, value: any) {
        var dom = this.domNode as any;
        if (name === 'height' || name === 'width') {
            if (value) {
                dom.setAttribute(name, value);
            } else {
                dom.removeAttribute(name, value);
            }
        } else {
            super.format(name, value);
        }
    }
}

//Quill.register(VideoUrlBlot, true);
